import { Button } from '@mui/material'




const FreecomersBtn = ({ onClick, mode, btntxt, size }) => {

    if (mode === 'redish') {
        return (
            <Button onClick={onClick}
                sx={{
                    borderRadius: "50px",
                    padding: size === "small" ? "5px 20px" : "6px 30px",
                    textTransform: 'none',
                    fontSize: size === "small" ? "14px" : "18px",
                    color: "#fcfcfc",
                    background: "linear-gradient(135deg, #282828, #951814)",
                    transition: "background 0.3s ease",
                    "&:hover": {
                        background: "linear-gradient(135deg, #951814, #282828)",
                    },
                }}
            >
                {btntxt}
            </Button>
        )
    }

    if (mode === 'yellowish') {
        return (
            <Button onClick={onClick}
                sx={{
                    borderRadius: "50px",
                    padding: size === "small" ? "5px 20px" : "6px 30px",
                    textTransform: 'none',
                    fontSize: size === "small" ? "14px" : "18px",
                    color: "#fcfcfc",
                    background: "linear-gradient(135deg, #282828, #E3C353)",
                    transition: "background 0.3s ease",
                    "&:hover": {
                        background: "linear-gradient(135deg, #E3C353, #282828)",
                    },
                }}
            >
                {btntxt}
            </Button>
        )
    }

    if (mode === 'greyish') {
        return (
            <Button onClick={onClick}
                sx={{
                    borderRadius: "50px",
                    padding: size === "small" ? "5px 20px" : "6px 30px",
                    textTransform: 'none',
                    fontSize: size === "small" ? "14px" : "18px",
                    color: "#fcfcfc",
                    background: "linear-gradient(135deg, #282828, #8E8E8E)",
                    transition: "background 0.3s ease",
                    "&:hover": {
                        background: "linear-gradient(135deg, #8E8E8E, #282828)",
                    },
                }}
            >
                {btntxt}
            </Button>
        )
    }

    if (mode === 'beigeish') {
        return (
            <Button onClick={onClick}
                sx={{
                    borderRadius: "50px",
                    padding: size === "small" ? "5px 20px" : "6px 30px",
                    textTransform: 'none',
                    fontSize: size === "small" ? "14px" : "18px",
                    color: "#282828",
                    background: "#F2EBE2",
                }}
            >
                {btntxt}
            </Button>
        )
    }

    return (
        <Button
            onClick={onClick}
            variant='text'
        sx={{ textTransform: "none", color: "inherit" }}
        >
            {btntxt}
        </Button>
    )
}

export default FreecomersBtn
